import { Button } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from './containers/icon';
const DownloadButton = ({
  url: _url = '',
  documentTitle: _documentTitle = '',
  buttonText: _buttonText = ''
}) => {
  const msg = _buttonText.length ? _buttonText : 'Download';
  const button = /*#__PURE__*/React.createElement(Button, {
    download: true,
    href: _url
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "download"
  }), " ", msg);
  const hasTitle = _documentTitle && _documentTitle.length;
  const hasURL = _url === null || _url === void 0 ? void 0 : _url.length;
  const alert = `
    Your browser is not compatible with this PDF viewer. Please try Google
    Chrome${hasURL ? ', or click the Download button below to download the PDF' : ''}.
  `;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Could not display ", hasTitle ? `"${_documentTitle}"` : 'the file', "."), /*#__PURE__*/React.createElement("p", null, alert), hasURL ? button : null);
};
DownloadButton.propTypes = {
  url: PropTypes.string,
  documentTitle: PropTypes.string,
  buttonText: PropTypes.string
};
export default DownloadButton;